const defaults = {
  development: 'http://localhost:8080',
  production: '/api',
  test: '/api'
};

const inferEnv = () => {
  const nodeEnv = process.env.NODE_ENV || 'development';
  const fallback = defaults[nodeEnv] ?? defaults.development;

  return {
    API_ENDPOINT_URL:
      process.env.REACT_APP_API_ENDPOINT_URL?.trim() || fallback
  };
};

export const env = inferEnv();
